import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_VERSION, PORTAL_LOGO_LONG, PORTAL_LOGO_MINI } from "../../Util/constant";
import ThemeToggelSwitch from "./ThemeToggelSwitch";
import { UseProfileContext } from "../context/ProfileContext";
import { UseConfigContext } from "../context/ConfigContext";
import { compactNumberWithTooltip } from "../user-pages/ui-helper";
import { Collapse } from "react-bootstrap";
import { checkBrokerPanelUser } from "../../Util/helper_functions";
import { useToolSubscriptionContext } from "../context/ToolSubscriptionContext";
const Sidebar = () => {
    const location = useLocation();
    const { profileData } = UseProfileContext();
    const { configData } = UseConfigContext();
    const { toolSubscriptionData } = useToolSubscriptionContext();
    const [menuStates, setMenuStates] = useState({
        toolMenuOpen: false,
    });
    const isPathActive = (path) => {
        return location.pathname.startsWith(path);
    };

    const onRouteChanged = () => {
        document.querySelector("#sidebar").classList.remove("active");
    };

    React.useEffect(() => {
        onRouteChanged();

        // Add hover effect for sidebar icon-only mode
        const body = document.querySelector("body");
        const navItems = document.querySelectorAll(".sidebar .nav-item");

        navItems.forEach((el) => {
            el.addEventListener("mouseover", () => {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.add("hover-open");
                }
            });
            el.addEventListener("mouseout", () => {
                if (body.classList.contains("sidebar-icon-only")) {
                    el.classList.remove("hover-open");
                }
            });
        });

        return () => {
            navItems.forEach((el) => {
                el.removeEventListener("mouseover", () => { });
                el.removeEventListener("mouseout", () => { });
            });
        };
    }, [location.pathname]);
    // Function to toggle menu state
    const toggleMenuState = (menuState) => {
        setMenuStates((prevState) => {
            const newState = {
                ...prevState,
                [menuState]: !prevState[menuState],
            };


            return newState;
        });
    };
    return (
        <nav className="sidebar sidebar-offcanvas fixed-sidebar" id="sidebar">
            <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
                <a className="sidebar-brand brand-logo" href="index.html">
                    <img src={PORTAL_LOGO_LONG} alt="logo" />
                </a>
                <a className="sidebar-brand brand-logo-mini" href="index.html">
                    <img src={PORTAL_LOGO_MINI} alt="logo" />
                </a>
            </div>
            <ul className="nav">
                <li className="nav-item nav-category">
                    <span className="nav-link pb-0">
                        User
                        <span className="nav-link ml-2 py-0">
                            [ {APP_VERSION} ]
                        </span>
                    </span>
                </li>
                <li className={isPathActive("/dashboard") ? "nav-item menu-items active" : "nav-item menu-items"}>
                    <Link className="nav-link" to="/dashboard">
                        <span className="menu-icon">
                            <i className="mdi mdi-speedometer text-success"></i>
                        </span>
                        <span className="menu-title">
                            Dashboard
                        </span>
                    </Link>
                </li>
                <li className={isPathActive("/demat") ? "nav-item menu-items active" : "nav-item menu-items"}>
                    <Link className="nav-link" to="/demat">
                        <span className="menu-icon">
                            <i className="mdi mdi-account-box text-info"></i>
                        </span>
                        <span className="menu-title">
                            Demat
                        </span>
                    </Link>
                </li>
                {checkBrokerPanelUser() && (
                    <>
                        <li className={isPathActive("/strategy") ? "nav-item menu-items active" : "nav-item menu-items"}>
                            <Link className="nav-link" to="/strategy">
                                <span className="menu-icon">
                                    <i className="mdi mdi-lightbulb-outline text-warning"></i>
                                </span>
                                <span className="menu-title">
                                    Strategy
                                </span>
                            </Link>
                        </li>
                        <li className={isPathActive("/mystrategy") ? "nav-item menu-items active" : "nav-item menu-items"}>
                            <Link className="nav-link" to="/mystrategy">
                                <span className="menu-icon">
                                    <i className="mdi mdi-chart-line text-primary"></i>
                                </span>
                                <span className="menu-title">
                                    My Strategy
                                </span>
                            </Link>
                        </li>
                        {profileData?.tool_permit && (
                            <>
                                {/* SHOW FULL MENU  */}
                                {(profileData?.is_tool_free || (profileData?.has_tools_subscription && toolSubscriptionData &&
                                    !toolSubscriptionData?.is_expired)) ? (
                                    <li className={`nav-item menu-items ${isPathActive("/tools") ? "active" : ""}`}>
                                        <Link className={`nav-link ${menuStates.toolMenuOpen ? "menu-expanded" : ""}`} onClick={() => toggleMenuState("toolMenuOpen")} to="/tools"     >
                                            <span className="menu-icon">
                                                <i className="mdi mdi-toolbox-outline text-info" ></i>
                                            </span>
                                            <span className="menu-title">Tools</span>
                                            <i className="menu-arrow text-white" ></i>

                                        </Link>
                                        <Collapse in={menuStates.toolMenuOpen}>
                                            <ul className="nav flex-column sub-menu">

                                                <li className="nav-item">
                                                    <Link className={`nav-link ${isPathActive("/tools/jsonbridge") ? "active" : ""}`} to="/tools/jsonbridge" 	>
                                                        Json Bridge
                                                    </Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link className={`nav-link ${isPathActive("/tools/custombridge") ? "active" : ""}`} to="/tools/custombridge" 	>
                                                        Custom Bridge
                                                    </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${isPathActive("/tools/chartink") ? "active" : ""}`} to="/tools/chartink" 	>
                                                        Chartink
                                                    </Link>
                                                </li>
                                                <li className="nav-item">
                                                    <Link className={`nav-link ${isPathActive("/tools/ordermanager") ? "active" : ""}`} to="/tools/ordermanager" 	>
                                                        Order Manager
                                                    </Link>
                                                </li>

                                            </ul>
                                        </Collapse>
                                    </li>
                                ) : (
                                    /* SHOW ONLY LOCKED TOOLS ITEM */
                                    <li className={`nav-item menu-items ${isPathActive("/tools") ? "active" : ""}`}>
                                        <Link className="nav-link" to="/tools" >
                                            <span className="menu-icon">
                                                <i className="mdi mdi-toolbox-outline  text-info"></i>
                                            </span>
                                            <span className="menu-title">
                                                Tools
                                            </span>
                                        </Link>
                                    </li>
                                )}
                            </>
                        )}
                    </>
                )}

                <li className={`nav-item menu-items ${isPathActive("/orderhistory") ? "active" : ""}`}>
                    <Link className="nav-link" to="/orderhistory" >
                        <span className="menu-icon">
                            <i className="mdi mdi-history text-danger"></i>
                        </span>
                        <span className="menu-title">
                            Order History
                        </span>
                    </Link>
                </li>
                {/* WHEN PAYMENT ENABLE THAN SHOWS REFERRAL AND WALLET MENU */}
                {checkBrokerPanelUser() && (
                    configData?.payment_enabled && (
                        <>
                            <li className={isPathActive("/wallet") ? "nav-item menu-items active" : "nav-item menu-items"}>
                                <Link className="nav-link" to="/wallet">
                                    <span className="menu-icon">
                                        <i className="mdi mdi-wallet text-info"></i>
                                    </span>
                                    <span className="menu-title">
                                        Wallet <span className="text-success">({compactNumberWithTooltip(profileData?.current_credit, "Current Credit")})</span>
                                    </span>
                                </Link>
                            </li>
                            <li className={isPathActive("/referral") ? "nav-item menu-items active" : "nav-item menu-items"}>
                                <Link className="nav-link" to="/referral">
                                    <span className="menu-icon">
                                        <i className="mdi mdi-share-variant  text-warning"></i>
                                    </span>
                                    <span className="menu-title">
                                        Referral
                                    </span>
                                </Link>
                            </li>
                        </>
                    )
                )}

                <li className={isPathActive("/activitylogs") ? "nav-item menu-items active" : "nav-item menu-items"}>
                    <Link className="nav-link" to="/activitylogs">
                        <span className="menu-icon">
                            <i className="mdi mdi-calendar-clock text-primary"></i>
                        </span>
                        <span className="menu-title">
                            Activity Logs
                        </span>
                    </Link>
                </li>
                <li className={isPathActive("/profile") ? "nav-item menu-items active" : "nav-item menu-items"}>
                    <Link className="nav-link" to="/profile">
                        <span className="menu-icon">
                            <i className="mdi mdi-account-circle text-success"></i>
                        </span>
                        <span className="menu-title">
                            Profile
                        </span>
                    </Link>
                </li>

                {/* <li className="nav-item menu-items">
					<div className="nav-link">
						<span className="menu-title">
							<ThemeToggelSwitch />
						</span>
					</div>
				</li> */}
            </ul>
        </nav>
    );
};

export default Sidebar;
